<template>
<DialogTemplate>
  <template #title>
    <t path="">Text Editor</t>
  </template>
  <div class="fill mt-12">
    <textarea :draggable="false" class="d-text br-lg" v-model="text"></textarea>
  </div>
  <template #cancel>
    <Button class="flex-1 btn" @click="cancel">
      <t path="" #="{td}" custom>{{td || 'Cancel'}}</t>
    </Button>
  </template>
  <template #confirm>
    <Button class="flex-1 btn primary" @click="ok">
      <t path="" #="{td}" custom>{{td || 'OK'}}</t>
    </Button>
  </template>
</DialogTemplate>
</template>

<script lang="ts">
import DialogTemplate from '@/views/DialogTemplate.vue'
import { defineComponent, shallowRef } from 'vue'

export default defineComponent({
  name: 'TheDrawTextDialog',
  components: { DialogTemplate },
  props: {
    oldVal: String,
  },
  emits: ['close', 'cancel', 'ok'],
  setup (props, ctx) {
    const text = shallowRef(props.oldVal)
    return {
      text,
      cancel: () => {
        ctx.emit('close')
        ctx.emit('cancel')
      },
      ok: () => {
        if (text.value === '') {
          return false
        }
        ctx.emit('close')
        ctx.emit('ok', text.value)
      },
    }
  },
})
</script>

<style scoped>
.d-text{
  width: 100%;
  height: 120px;
  background: var(--color-hover);
  border: 1px solid var(--color-border);
  outline: none;
  padding: 12px 10px;
  font-size: 14px;
  resize: none;
}
</style>
